import "bootstrap/dist/css/bootstrap.css";
// import 'bootstrap/dist/css/bootstrap-theme.css';
import "font-awesome/css/font-awesome.css";
import "nprogress/nprogress.css";
// react-select styles are included directly through LESS!
//import "react-select/dist/react-select.css";
import "icheck/skins/square/green.css";
import "./css/animate.css";
import "./css/style.css";
import "./css/restserver.css";

import "./globals";
import "babel-polyfill";

import React from "react";
import ReactDOM from "react-dom";
import Log from "./Log";
import App from "./App";
import {NotFoundException} from "./Exceptions";
import ErrorApplication from "./pages/ErrorApplication";
import ErrorNotFound from "./pages/ErrorNotFound";

function getErrorPage(e) {
    if (e instanceof NotFoundException) return (<ErrorNotFound/>);
    return (<ErrorApplication/>);
}

try {
    ReactDOM.render(
        <App />,
        document.getElementById("root")
    );
} catch (e) {
    Log.exception(e);
    ReactDOM.render(
        getErrorPage(e),
        document.getElementById("root")
    );
    throw e;
}
